/** @format */

import "./login.css";
import { FaCheckCircle, FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import Card from "react-bootstrap/Card";
import LoginCarouselSlide from "./Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  GenerateOtp,
  LoginUser,
  showNotification,
} from "../../Repository/Apis";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import { SignInFirebase } from "../../utils/utils";
import { LoginSlice, SetFirebaseUser } from "../../store/authSlice";

const Login = () => {
  const [showPasswordLogin, setShowPasswordLogin] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [showLoginOtp, setShowLoginOtp] = useState(false);
  const [loginOtp, setLoginOtp] = useState("");
  const [showResetPasswordLink, setShowResetPasswordLink] = useState(false);
  // const [confirmPassword, setConfirmPassword] = useState("");
  // const [newPassword, setNewPassword] = useState("");
  const [userId, setUserId] = useState("");
  // const [oldPassword, setOldPassword] = useState("");
  const [passwordResetLinkMsg, setPasswordResetLinkMsg] = useState("");

  const dispatch = useDispatch();

  const payload = {
    email: email.toLowerCase()?.trim(),
    password: password?.trim(),
    otp: loginOtp.trim(),
  };

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate("/dashboard");
  //   }
  // }, [isLoggedIn]);

  const resendOTP = async (e) => {
    e.preventDefault(); // Prevent form submission
    setLoginOtp("");
    if (!email?.trim() || !password?.trim()) {
      showNotification({
        message: "Username and Passwords fields cannot be empty",
        type: "danger",
      });
      return;
    }

    try {
      setLoading(true);
      const res = await GenerateOtp({
        setLoading,
        payload,
      });
      if (res?.status === 200) {
        // showNotification({ message: "OTP successfully resent", type: "success" });
      } else {
        showNotification({ message: "Failed to resend OTP", type: "danger" });
      }
    } catch (error) {
      const msg = error?.response?.data?.message || "An error occurred";
      showNotification({ message: msg, type: "danger" });
    } finally {
      setLoading(false);
    }
  };
  const forgetPasswordResendOTP = async (e) => {
    setOtp("");
    if (!email?.trim()) {
      showNotification({
        message: "Username fields cannot be empty",
        type: "danger",
      });
      return;
    }
    e.preventDefault(); // Prevent form submission
    try {
      const res = await axios.post(
        `${process.env.React_App_Baseurl}employee/forgetPassword`,
        {
          email,
        }
      );
      const otp = res?.data?.data?.otp;
      showNotification({
        message: "OTP Successfully send to your email",
        type: "success",
      });
      setShowOtp(true);
    } catch (error) {
      const msg = error?.response?.data?.message || "An error occurred";
      showNotification({ message: msg, type: "danger" });
    } finally {
      // setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!showLoginOtp) {
      if (!email?.trim() || !password?.trim()) {
        showNotification({
          message: "Username and Passwords fields cannot be empty",
          type: "danger",
        });
        return;
      }
      const res = await GenerateOtp({
        setLoading,
        payload,
      });
      if (res?.status === 200) {
        if (
          res?.data?.message === "Login successful." &&
          res?.data?.accessToken
        ) {
          const data = {
            profile: res?.data,
            payload,
            timeStamp: Date.now(),
          };

          try {
            setShowLoginOtp(false);
            dispatch(LoginSlice(data));
            const firebaseUser = await SignInFirebase({
              payload: res?.data?.data,
            });
            dispatch(SetFirebaseUser(firebaseUser));
            setLoading(false);
            if (res?.data?.data?.userType === "Admin") {
              navigate("/dashboard/homepage");
            } else if (res?.data?.data?.userType === "Patient") {
              navigate("/patient_panel");
            }else if (res?.data?.data?.userType === "Guardian") {
              navigate("/patient_panel");
            } else {
              navigate("/Home");
            }
            showNotification({ message: "Welcome" });
          } catch (err) {
            setLoading(false);
            showNotification({ message: "Failed login", type: "danger" });
          }
        } else {
          setShowLoginOtp(true);
        }
      } else {
        setShowLoginOtp(false);
      }
    } else {
      // dispatch(
      //   LoginUser({
      //     setLoading,
      //     payload,
      //     navigate,
      //   })
      try {
        if (!email?.trim() || !password?.trim()) {
          showNotification({
            message: "Username and Passwords fields cannot be empty",
            type: "danger",
          });
          return;
        }
        const { data } = await dispatch(
          LoginUser({
            setLoading,
            payload,
            navigate,
          })
        ).then((payload) => Promise.resolve(payload));
        const firebaseUser = await SignInFirebase({ payload: data });
        dispatch(SetFirebaseUser(firebaseUser));
        setLoading(false);
        if (data?.userType === "Admin") {
          navigate("/dashboard/homepage");
        } else if (data?.userType === "Patient") {
          navigate("/patient_panel");
        } else if (data?.userType === "Guardian") {
          navigate("/patient_panel");
        }else {
          navigate("/Home");
        }
        showNotification({ message: "Welcome" });
      } catch (err) {
        setLoading(false);
        showNotification({ message: err?.response?.data?.message || "Invalid OTP", type: "danger" });
      }
    }
  };

  const handleForget = async (e) => {
    e.preventDefault();
    if (showOtp) {
      if (!email?.trim()) {
        showNotification({
          message: "Username fields cannot be empty",
          type: "danger",
        });
        return;
      }
      try {
        setLoading(true)
        const res = await axios.post(
          `${process.env.React_App_Baseurl}employee/forgotVerifyOtp`,
          {
            email,
            otp,
          }
        );
        setUserId(res?.data?.data?.userId);
        setShowOtp(false);
        setForgetPassword(false);
        setShowResetPasswordLink(true);
        showNotification({ message: "Otp verified successfully" });
        setPasswordResetLinkMsg(res?.data?.message);
        if(res){
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        const msg = error?.response?.data?.message || "An error occurred";
        showNotification({ message: msg, type: "danger" });
      }
    } 
  
    // else if (showPassword) {
    //   const validatePassword = (password) => {
    //     const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    //     return passwordRegex.test(password);
    //   };
    //   if (!newPassword?.trim() || !confirmPassword?.trim() || !oldPassword?.trim()) {
    //     showNotification({ message: "Passwords fields cannot be empty", type: "danger" });
    //     return;
    //   }

    //   if (newPassword !== confirmPassword) {
    //     showNotification({ message: "Confirm password does not match the password", type: "danger" });
    //     return
    //   }

    //   if (!validatePassword(newPassword?.trim())) {
    //     showNotification({
    //       message:
    //         "Password must be 8 characters long, include at least one uppercase letter, one lowercase letter, one number, and one special character.",
    //       type: "danger"
    //     });
    //     return;
    //   }

    //   try {
    //     const res = await axios.post(
    //       `${process.env.React_App_Baseurl}employee/changePassword/${userId}`,
    //       {
    //         newPassword: newPassword?.trim(),
    //         confirmPassword: confirmPassword?.trim(),
    //         password: oldPassword?.trim(),
    //       }
    //     );
    //     setShowOtp(false);
    //     // setShowPassword(true);
    //     const msg = res?.data?.message;
    //     showNotification({ message: msg });
    //     setForgetPassword(false);
    //     setShowOtp(false);
    //     // setShowPassword(false);
    //   } catch (error) {
    //     const msg = error?.response?.data?.message || "An error occurred";
    //     showNotification({ message: msg, type: "danger" });
    //   }
    // }
    else {
      if (!email?.trim()) {
        showNotification({
          message: "Username fields cannot be empty",
          type: "danger",
        });
        return;
      }
      try {
        const res = await axios.post(
          `${process.env.React_App_Baseurl}employee/forgetPassword`,
          {
            email,
          }
        );
        const otp = res?.data?.data?.otp;
        showNotification({
          message: "OTP Successfully send to your email",
          type: "success",
        });
        setShowOtp(true);
      } catch (error) {
        const msg = error?.response?.data?.message || "An error occurred";
        showNotification({ message: msg, type: "danger" });
      }
    }
  };

  const closeAll = () => {
    setForgetPassword(false);
    setShowOtp(false);
    setShowResetPasswordLink(false);
  };

  return (
    <>
      <div className="v-application__wrap">
        <Container fluid className="p-lg-0">
          <Row className="align-items-center">
            <Col xs={12} lg={6}>
              <div className="login-carousel">
                <LoginCarouselSlide />
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="login-cred">
                <div className="bg-blur">
                  <div className="round-1"></div>
                  <div className="round-2"></div>
                </div>
                <div className="login-logo text-center">
                  <img src="/logo.png" alt="logo" />
                </div>
                <Card>
                  <Card.Body>
                    <div className="right-div-login-page px-0 px-lg-4">
                      <div>
                        <h4
                          style={{
                            color: "#1a9fb2",
                            textAlign: "center",
                          }}
                          className="fw-bold"
                        >
                          Login Panel
                        </h4>
                      </div>
                      <div className="Main">
                        {forgetPassword ? (
                          <Form
                            onSubmit={handleForget}
                            style={{
                              marginTop: "2rem",
                              textAlign: "left",
                              width: "100%",
                            }}
                          >
                            <p style={{ fontSize: "14px" }}>
                              If you have verified the email address for your
                              user account, enter your User ID here and we’ll
                              email you a link to reset your password
                            </p>

                            <Form.Group className="mb-3">
                              <Form.Label className="fw-bold">
                                Email ID{" "}
                              </Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={email}
                                placeholder="Enter email"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </Form.Group>
                            {showOtp && (
                              <Form.Group className="mb-3">
                                <div className=" justify-content-between align-items-center">
                                  <Form.Label className="fw-bold">
                                    OTP{" "}
                                  </Form.Label>
                                  <button
                                    style={{ color: "#68BFCC" }}
                                    onClick={forgetPasswordResendOTP}
                                    className="resend-otp-btn"
                                    type="button"
                                  >
                                    Resend OTP
                                  </button>
                                </div>
                                <Form.Control
                                  type="tel"
                                  name="otp"
                                  value={otp}
                                  placeholder="Enter OTP"
                                  onChange={(e) => {
                                    const value = e.target.value?.trim();
                                    if (/^\d*$/.test(value)) {
                                      setOtp(value);
                                    }
                                  }}
                                />
                              </Form.Group>
                            )}

                            {/* {showPassword && (
                              <div>
                                <Form.Group className="mb-3">
                                  <Form.Label className="fw-bold">Enter Old Password</Form.Label>
                                  <Form.Control
                                    type="password"
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    placeholder="Enter old password"
                                    value={oldPassword}
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label className="fw-bold">New Password </Form.Label>
                                  <Form.Control
                                    type="password"
                                    placeholder="New Passowrd"
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    minLength={6}
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label className="fw-bold">Confirm Password </Form.Label>
                                  <Form.Control
                                    type="password"
                                    placeholder="Confirm Passowrd"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    minLength={6}
                                  />
                                </Form.Group>
                              </div>
                            )} */}

                            <Form.Group
                              className="mb-3"
                              controlId="formBasicCheckbox"
                            ></Form.Group>
                            <div
                              style={{
                                width: "100%",
                                margin: "auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                marginTop: "2rem",
                              }}
                            >
                              <div className="forget-pass-btns">
                                <Button
                                  variant="primary"
                                  type="submit"
                                  className="sendLink"
                                >
                                  Submit
                                </Button>
                                <Button
                                  variant="primary"
                                  type="button"
                                  className="Cancel"
                                  onClick={() => closeAll()}
                                >
                                  Cancel
                                </Button>
                              </div>
                              <p
                                style={{
                                  color: "#444",
                                  width: "100%",
                                  textAlign: "center",
                                  marginTop: "2rem",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                If you have not verified your email address,
                                please contact your onsite System Administrator
                                for help resetting your password.
                              </p>

                              <hr style={{ color: "gray" }} />
                              <p style={{ opacity: "60%", fontSize: "14px" }}>
                                By logging in, you agree to the{" "}
                                <span
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    opacity: "100%",
                                    // fontWeight: "bold",
                                    fontSize: "14px",
                                  }}
                                >
                                  End User License Agreement
                                </span>{" "}
                              </p>
                              <p
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  color: "#1a9fb2",
                                  // fontWeight: "bold",
                                  marginTop: "1rem",
                                  flexWrap: "wrap",
                                  fontSize: "14px",
                                }}
                                className="mb-0"
                              >
                                {/* <span>What’s New</span> */}
                                {/* <span>Profile Updates</span> */}
                                {/* <span>Status Page</span> */}
                              </p>
                            </div>
                          </Form>
                        ) : showResetPasswordLink ? (
                          <div
                            style={{
                              marginTop: "3rem",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            <Alert variant="success">
                              <span className="d-flex align-items-center justify-content-center gap-2">
                                <FaCheckCircle className="fs-5" variant="success" />
                                <span className="fs-5">{passwordResetLinkMsg}</span>
                              </span>
                            </Alert>
                            <div className="forget-pass-btns mt-3">
                             
                                <Button
                                  variant="primary"
                                  type="button"
                                  className="Cancel"
                                  onClick={() => closeAll()}
                                >
                                   Go Back to Login Page 
                                </Button>
                              </div>
                          </div>
                        ) : (
                          <Form
                            style={{
                              marginTop: "2rem",
                              textAlign: "left",
                              width: "100%",
                            }}
                            onSubmit={handleSubmit}
                          >
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fw-bold">
                                Email ID{" "}
                              </Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Enter email"
                                required
                                value={email}
                                name="email"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </Form.Group>

                            <Form.Group className="password_input_group mb-3">
                              <Form.Label className="fw-bold">
                                Password
                              </Form.Label>
                              <div style={{ position: "relative" }}>
                                <Form.Control
                                  type={showPasswordLogin ? "text" : "password"}
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="Password"
                                  className="pe-5"
                                  minLength={6}
                                  required
                                />{" "}
                                <div
                                  onClick={() =>
                                    setShowPasswordLogin(!showPasswordLogin)
                                  }
                                  style={{
                                    position: "absolute",
                                    top: "30%",
                                    display: "inline-block",
                                    backgroundColor: "#fff",
                                    right: "8px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {!showPasswordLogin ? (
                                    <FaEye />
                                  ) : (
                                    <FaEyeSlash />
                                  )}
                                </div>
                              </div>
                            </Form.Group>
                            {showLoginOtp && (
                              <div className=" justify-content-between align-items-center">
                                <button
                                  style={{ color: "#68BFCC" }}
                                  onClick={resendOTP}
                                  className="resend-otp-btn"
                                  type="button"
                                >
                                  Resend OTP
                                </button>
                              </div>
                            )}
                            {showLoginOtp && (
                              <Form.Group className="mb-3">
                                <Form.Label className="fw-bold">OTP</Form.Label>
                                <Form.Control
                                  type="tel"
                                  name="otp"
                                  placeholder="Enter OTP"
                                  value={loginOtp}
                                  onChange={(e) => {
                                    const value = e.target.value?.trim();
                                    if (/^\d*$/.test(value)) {
                                      setLoginOtp(value);
                                    }
                                  }}
                                />
                              </Form.Group>
                            )}

                            <div
                              style={{
                                width: "100%",
                                margin: "auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                marginTop: "2rem",
                              }}
                            >
                              <Button
                                className="login_btn"
                                variant="primary"
                                type="submit"
                              >
                                {loading ? (
                                  <ClipLoader color="#fff" />
                                ) : showOtp ? (
                                  "Submit OTP"
                                ) : (
                                  "Login"
                                )}
                              </Button>

                              <button
                                className="forget_password"
                                onClick={() => {setForgetPassword(true); setEmail(''); setPassword('')}}
                              >
                                {" "}
                                Forgot Your Password?
                              </button>

                              <hr style={{ color: "gray" }} />
                              <p style={{ opacity: "60%", fontSize: "14px" }}>
                                By logging in, you agree to the{" "}
                                <span
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    opacity: "100%",
                                    // fontWeight: "bold",
                                  }}
                                >
                                  End User License Agreement
                                </span>{" "}
                              </p>
                              <p
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  color: "#1a9fb2",
                                  // fontWeight: "bold",
                                  marginTop: "1rem",
                                  flexWrap: "wrap",
                                  fontSize: "14px",
                                }}
                                className="mb-0"
                              >
                                {/* <span>What’s New</span> */}
                                {/* <span>Profile Updates</span> */}
                                {/* <span>Status Page</span> */}
                              </p>
                            </div>
                          </Form>
                        )}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Login;
